import { HTMLContentModel, HTMLElementModel } from 'react-native-render-html'

export const messagePreviewTextStyles = {
  code: HTMLElementModel.fromCustomModel({
    tagName: 'code',
    mixedUAStyles: {
      fontFamily: 'monospace'
    },
    contentModel: HTMLContentModel.block
  }),
  s: HTMLElementModel.fromCustomModel({
    tagName: 's',
    mixedUAStyles: {
      textDecorationLine: 'line-through'
    },
    contentModel: HTMLContentModel.block
  })
}

interface FormatRule {
  regex: RegExp
  tag: string
  list?: string
}

const formatRules: FormatRule[] = [
  { regex: /```([^`]+)```/g, tag: 'code' },
  { regex: /_([^_]+)_/g, tag: 'i' },
  { regex: /~([^~]+)~/g, tag: 's' },
  { regex: /([\r\n])/g, tag: 'br' },
  { regex: /\*([^*]+)\*/g, tag: 'b' },
  { regex: /\n[*|-] (.*)/g, tag: 'li', list: 'ul' },
  { regex: /\n(\d+)\. (.*)/g, tag: 'li', list: 'ol' }
]

export const normalizeInHtml = (str: string): string => {
  if (!str) return str

  let formattedStr = str

  formatRules.forEach(rule => {
    formattedStr = formattedStr.replace(rule.regex, (...groups) => {
      let tag: string
      const value = groups[1]
      switch (rule.tag) {
        case 'br':
          tag = `<${rule.tag} />`
          break
        default:
          tag = `<${rule.tag}>${value}</${rule.tag}>`
          break
      }
      if (rule.list) return `<${rule.list}>${tag}</${rule.list}>`
      return tag
    })
  })

  return formattedStr
}
